export default __webpack_public_path__ + "locales/pl/Settings.json?hash=fe193a5611837be0723d5fcc7e4dcb03";